import { render, staticRenderFns } from "./follwUpExamMonthDetail.vue?vue&type=template&id=00edf0f1"
import script from "./follwUpExamMonthDetail.vue?vue&type=script&lang=js"
export * from "./follwUpExamMonthDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00edf0f1')) {
      api.createRecord('00edf0f1', component.options)
    } else {
      api.reload('00edf0f1', component.options)
    }
    module.hot.accept("./follwUpExamMonthDetail.vue?vue&type=template&id=00edf0f1", function () {
      api.rerender('00edf0f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/fue/follwUpExamMonthDetail.vue"
export default component.exports